/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2487
 */

module.exports = function (e) {
  var /* [auto-meaningful-name] */this$__data__ = this.__data__
  var n = this$__data__.delete(e)
  this.size = this$__data__.size
  return n
}
